import i18n from '@/i18n';
import Goods from './Goods';
import Orders from './Orders'; //$IMPORT$
import Transport from './Transport';
import TransportDriver from './TransportDriver';

export default () => [
  {
    resourceName: i18n.t('mall-index-1992f2b81cd6d959c-1'),
    routerUrl: '/mall',
    resourceIcon: '',
    type: '0',
    buttons: [],
    children: [
      Goods(),
      Orders(), //$MORE$
      Transport(),
      TransportDriver(),
    ],
  },
];
